module.exports = __webpack_public_path__ + "img/add-white.a4599afb.svg";